import isString from "lodash/isString";

export const formatPhone = (value) => {
  if (!value || !isString(value)) return "";
  // Remove all non-digits
  const digits = value.replace(/[^\d]/g, "");

  // Format as (XXX) XXX-XXXX if more than 6 digits
  if (digits.length > 6) {
    return `(${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(
      6,
      10
    )}`;
  }
  // Format as (XXX) XXX if between 4 and 6 digits
  if (digits.length > 3) {
    return `(${digits.slice(0, 3)}) ${digits.slice(3)}`;
  }
  return digits;
};
